<form [formGroup]="teamsService.memberAdditionForm" class="d-flex flex-column custom-modal-content">
    <div class='my-5'>
            <app-input-field [parentForm]='teamsService.memberAdditionForm' [inputJson]='idFieldObject'>
            </app-input-field>
    </div>
</form>